// Download URIs are 15-minute SAS links minted when the rows are fetched. Past this age,
// refetch before opening so the customer never lands on an expired link.
const DOWNLOAD_URI_MAX_AGE_MS = 14 * 60 * 1000

/**
 * The download URI for an attachment row, refetching the rows first when the link may have expired.
 *
 * @param {Object} params
 * @param {Object} params.attachment - The DocumentDto row being downloaded
 * @param {number} [params.fetchedAt] - When the rows were last fetched (RTK Query `fulfilledTimeStamp`)
 * @param {Function} params.refetchRows - Refetches and resolves to the fresh rows; rejects on failure
 * @returns {Promise<string|undefined>}
 */
export const freshDownloadUri = async ({ attachment, fetchedAt, refetchRows }) => {
    if (fetchedAt && Date.now() - fetchedAt <= DOWNLOAD_URI_MAX_AGE_MS) {
        return attachment.downloadUri
    }
    const rows = await refetchRows()
    return rows?.find(({ documentId }) => documentId === attachment.documentId)?.downloadUri
}
